import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import styled from 'styled-components'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'

const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 40px 32px;
	text-align: center;
	height: 100%;
	justify-content: center;
	background-color: #fffbeb;
	box-sizing: border-box;

	& .icon-container {
		width: 64px;
		height: 64px;
		border-radius: 50%;
		background-color: #fef3c7;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 24px;
		border: 2px solid #f59e0b;

		& svg {
			font-size: 34px;
			color: #d97706;
		}
	}

	& .title {
		color: #92400e;
		margin-bottom: 20px;
		font-weight: 600;
	}

	& .message {
		color: #78350f;
		margin-bottom: 12px;
		line-height: 1.6;
		max-width: 280px;
	}

	& .quota-note {
		color: #a16207;
		font-style: italic;
		margin-bottom: 32px;
		max-width: 280px;
	}

	& .action-button {
		background-color: #f59e0b;
		color: white;
		padding: 12px 40px;
		border-radius: 8px;
		font-weight: 500;
		text-transform: none;
		font-size: 16px;

		&:hover {
			background-color: #d97706;
		}
	}
`

interface TeamToggledModalProps {
	onDismiss: () => void
}

const TeamToggledModal = ({ onDismiss }: TeamToggledModalProps) => {
	return (
		<ModalContainer>
			<div className="icon-container">
				<WarningAmberIcon />
			</div>
			<Typography variant="h6" className="title">
				Team-Enabled Tower
			</Typography>
			<Typography variant="body1" className="message">
				This tower was enabled by one of your teams.
				You cannot disable it yourself.
			</Typography>
			<Typography variant="body2" className="quota-note">
				Don't worry - it doesn't count against your personal quota.
			</Typography>
			<Button
				variant="contained"
				className="action-button"
				onClick={onDismiss}
			>
				Got it
			</Button>
		</ModalContainer>
	)
}

export default TeamToggledModal
